import React from 'react'
import styled from 'styled-components'
import CheckBox from '../CheckBox/CheckBox'
import {_L, useLocaleState} from '../../context/LocaleContext'

export const DIRECTION = {
  VERTICAL: 'column',
  HORIZONTAL: 'row'
}

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
  grid-gap: 6px;
  box-sizing: border-box;
`

const WeekDaySelect = ({value, direction, onChange}) => {
  const localeState = useLocaleState()

  const doChange = (index, checked) => {
    let selectedDaysCopy = value.slice(0)

    // Convert true/false checked value to 0/1
    selectedDaysCopy[index] = checked | 0

    onChange(selectedDaysCopy)
  }

  const dayLabels = [
    _L({key: 'Mon', localeState}),
    _L({key: 'Tue', localeState}),
    _L({key: 'Wed', localeState}),
    _L({key: 'Thu', localeState}),
    _L({key: 'Fri', localeState}),
    _L({key: 'Sat', localeState}),
    _L({key: 'Sun', localeState})
  ]

  return (
    <Container direction={direction}>
      {dayLabels.map((label, index) => (
        <CheckBox
          key={index}
          label={label}
          index={index}
          onChange={doChange}
          checked={!!value[index]}
        />
      ))}
    </Container>
  )
}

WeekDaySelect.defaultProps = {
  value: [0, 0, 0, 0, 0, 0, 0],
  onChange: () => {},
  direction: DIRECTION.VERTICAL
}

export default WeekDaySelect
